<div class="page-container" [class.loading]="isLoading">
    <app-header title="reporting.reports.benefitsDigest.title" [back]="true"></app-header>

    <ui-card>
        <p [innerHTML]="'reporting.reports.benefitsDigest.reportdescription' | translate"></p>

        <ui-banner variant="warning">
            <div class="content">
                <div class="header">{{ 'reporting.reports.benefitsDigest.header' | translate }}</div>
                <p [innerHTML]="'reporting.reports.benefitsDigest.changesNotForwarded' | translate"></p>
            </div>
        </ui-banner>
    </ui-card>

    <mat-chip-listbox [value]="showArchived ? 'archived' : 'active'" (change)="toggleArchived()">
        <mat-chip-option value="active">
            {{ 'reporting.reports.active' | translate }}
        </mat-chip-option>
        <mat-chip-option value="archived">
            {{ 'reporting.reports.archived' | translate }}
        </mat-chip-option>
    </mat-chip-listbox>

    <ng-container *ngIf="benefitsDigest$ | async as events">
        <ng-container *ngIf="events.length > 0; else emptyState">
            <ui-card *ngFor="let event of events">
                <ui-button *ngIf="!showArchived" type="primary" style="float: right" (click)="actionEvent(event)">
                    {{ 'reporting.reports.archive' | translate }}
                </ui-button>

                <!-- Descriptions -->
                <p>
                    <strong>
                        {{ event.createdAt | appDate: 'mediumDate' }}
                        {{
                            event.relatedTable
                                .replace(
                                    '_',
                                    '
                        '
                                )
                                .replace('_', ' ') | capitalize
                        }}
                        {{ 'reporting.reports.benefitsDigest.update' | translate }}
                    </strong>
                    <br />
                    {{
                        'reporting.reports.benefitsDigest.change'
                            | translate: { firstName: event.user?.firstName, lastName: event.user?.lastName }
                    }}
                    <span
                        *ngIf="
                            event.relatedColumn &&
                            event.relatedColumn !== 'dependents' &&
                            event.relatedColumn !== 'beneficiary'
                        "
                        [innerHTML]="
                            'reporting.reports.benefitsDigest.informationFor'
                                | translate
                                    : {
                                          eventRelatedColumn: event.relatedColumn,
                                          formattedPrevValue: formatValue(event.prevValue),
                                          formattedNewValue: formatValue(event.newValue),
                                      }
                        "
                    ></span>
                    <span *ngIf="event.relatedColumn === 'dependents'">
                        <span [innerHTML]="'reporting.reports.benefitsDigest.dependents' | translate"></span>
                    </span>
                    <span *ngIf="event.relatedColumn === 'beneficiary'">
                        <span [innerHTML]="'reporting.reports.benefitsDigest.beneficiary' | translate"></span>
                    </span>
                    <span *ngIf="!event.relatedColumn">{{
                        'reporting.reports.benefitsDigest.benefitInformationInExternalBenefitsPortal' | translate
                    }}</span>
                    <br />
                </p>
            </ui-card>

            <div class="loadable" [class.loading]="isLoadingMore"></div>
        </ng-container>

        <ng-template #emptyState>
            <ui-card>
                <p>{{ 'reporting.reports.benefitsDigest.noUpdatesToDisplay' | translate }}</p>
            </ui-card>
        </ng-template>
    </ng-container>
</div>
